var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "confi" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "stepWrapper",
          staticClass: "step-wrapper",
          class: { rdy: _vm.navInit },
        },
        [
          _c(
            "router-link",
            {
              staticClass: "step-outer",
              class: { done: _vm.Global.currentConfigStep > 1 },
              attrs: { tag: "div", to: "/infos" },
            },
            [
              _c("div", { staticClass: "shape" }, [
                _c("span", { staticClass: "main" }),
                _vm._v(" "),
                _c("div", { staticClass: "inner" }, [
                  _c("span", { staticClass: "num ft-xbld" }, [_vm._v("1")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checker" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "txt ft-bld",
                  style: { width: _vm.navStorage[0] + "px" },
                },
                [_vm._v("Your informations")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "step-outer",
              class: { done: _vm.Global.currentConfigStep > 2 },
              attrs: { tag: "div", to: "/content" },
            },
            [
              _c("div", { staticClass: "shape" }, [
                _c("span", { staticClass: "main" }),
                _vm._v(" "),
                _c("div", { staticClass: "inner" }, [
                  _c("span", { staticClass: "num ft-xbld" }, [_vm._v("2")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checker" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "txt ft-bld",
                  style: { width: _vm.navStorage[1] + "px" },
                },
                [_vm._v("Content")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "step-outer",
              class: { done: _vm.Global.currentConfigStep > 3 },
              attrs: { tag: "div", to: "/model" },
            },
            [
              _c("div", { staticClass: "shape" }, [
                _c("span", { staticClass: "main" }),
                _vm._v(" "),
                _c("div", { staticClass: "inner" }, [
                  _c("span", { staticClass: "num ft-xbld" }, [_vm._v("3")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checker" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "txt ft-bld",
                  style: { width: _vm.navStorage[2] + "px" },
                },
                [_vm._v("Business models")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "step-outer",
              class: { done: _vm.Global.currentConfigStep > 4 },
              attrs: { tag: "div", to: "/look" },
            },
            [
              _c("div", { staticClass: "shape" }, [
                _c("span", { staticClass: "main" }),
                _vm._v(" "),
                _c("div", { staticClass: "inner" }, [
                  _c("span", { staticClass: "num ft-xbld" }, [_vm._v("4")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checker" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "txt ft-bld",
                  style: { width: _vm.navStorage[3] + "px" },
                },
                [_vm._v("Look & feel")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "step-outer",
              class: { done: _vm.Global.currentConfigStep > 5 },
              attrs: { tag: "div", to: "/services" },
            },
            [
              _c("div", { staticClass: "shape" }, [
                _c("span", { staticClass: "main" }),
                _vm._v(" "),
                _c("div", { staticClass: "inner" }, [
                  _c("span", { staticClass: "num ft-xbld" }, [_vm._v("5")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checker" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "txt ft-bld",
                  style: { width: _vm.navStorage[4] + "px" },
                },
                [_vm._v("Additionnal services")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "step-outer",
              class: { done: _vm.Global.currentConfigStep > 6 },
              attrs: { tag: "div", to: "/payment" },
            },
            [
              _c("div", { staticClass: "shape" }, [
                _c("span", { staticClass: "main" }),
                _vm._v(" "),
                _c("div", { staticClass: "inner" }, [
                  _c("span", { staticClass: "num ft-xbld" }, [_vm._v("6")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checker" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "txt ft-bld",
                  style: { width: _vm.navStorage[5] + "px" },
                },
                [_vm._v("Payment")]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          ref: "outerCart",
          staticClass: "btn main cart",
          class: {
            dslbd: _vm.Global.currentConfigStep > 6,
            active: _vm.openedCart,
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleCart.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "prw" }, [
            _c("div", { staticClass: "ctnt" }, [
              _c("span", [_vm._v("Your price")]),
              _vm._v(" "),
              _c("span", [
                _c("span", { staticClass: "ft-xbld prce" }, [
                  _vm._v(_vm._s(_vm.cartTotal) + "€"),
                ]),
                _c("span", [_vm._v("/month")]),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "arw" }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "extend" },
            [
              _c("span", { staticClass: "cap-title ft-xbld" }, [
                _vm._v("Your cart"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.cartRows, function (row, index) {
                return _c("div", { key: index, staticClass: "line" }, [
                  _c("span", { staticClass: "caption" }, [
                    _vm._v(_vm._s(row.label)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "price ft-blk" }, [
                    _vm._v(_vm._s(row.price) + "€"),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c("div", { staticClass: "line w-price" }, [
                _c("span", { staticClass: "caption" }, [
                  _vm._v("Your final price"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price-outer" }, [
                  _c("span", { staticClass: "ft-xbld prce" }, [
                    _vm._v(_vm._s(_vm.cartTotal) + "€"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("/month")]),
                ]),
              ]),
            ],
            2
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("span", { staticClass: "shape" }),
      _vm._v(" "),
      _c("span", { staticClass: "text" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sep-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }